import { OrderEditableData, OrderModel } from 'lib/model/objects/orderModel';
import { NewspaperOrderModel } from 'lib/model/objects/newspaperOrderModel';
import { Badge } from 'lib/components/Badge';
import { capitalizeWord, decodeHtml } from 'lib/utils/strings';
import AdDetailHeaderSection from './AdDetailHeaderSection';
import { getBadgeStatusForOrderStatus, getStatusBadgeText } from '../helpers';
import { OrderActions } from './OrderActions';
import { OrderDetailBackButton } from './OrderDetailBackButton';

type AdDetailHeaderProps = {
  title?: string;
  order: OrderModel;
  editData: OrderEditableData | null;
  anonymousUserAuthInfo: { authEmail: string; accessCode: string } | undefined;
  newspaperOrders?: NewspaperOrderModel[];
};
export function AdDetailHeader({
  title,
  order,
  editData,
  anonymousUserAuthInfo,
  newspaperOrders
}: AdDetailHeaderProps) {
  return (
    <>
      <AdDetailHeaderSection>
        {!anonymousUserAuthInfo && <OrderDetailBackButton order={order} />}
        <h1 className="text-xl text-column-gray-500 font-bold">
          {decodeHtml(title ?? '')}
        </h1>
        <Badge
          status={getBadgeStatusForOrderStatus(order.modelData.status)}
          size="lg"
        >
          {capitalizeWord(getStatusBadgeText(order.modelData.status))}
        </Badge>
      </AdDetailHeaderSection>
      <AdDetailHeaderSection>
        <OrderActions
          order={order}
          editData={editData}
          anonymousUserAuthInfo={anonymousUserAuthInfo}
          newspaperOrders={newspaperOrders}
          adTitle={title}
        />
      </AdDetailHeaderSection>
    </>
  );
}
